import { Subpaths } from '@/types/enums/paths';

export const PASSWORD_PROTECTED_PATHS = [Subpaths.Account, Subpaths.Wallet, Subpaths.WalletPayment];
export const PRIVATE_PATHS = [
    Subpaths.Surveys,
    Subpaths.Profile,
    Subpaths.Account,
    Subpaths.Wallet,
    Subpaths.Referrals,
    Subpaths.SelectOpinion,
];
export const UNAVAILABLE_TO_LOGGED_IN_USERS_PATHS = [Subpaths.Login, Subpaths.Enroll];
export const PUBLIC_PATHS = [
    Subpaths.WalletIntro,
    Subpaths.ProfileIntro,
    Subpaths.LoginConfirmPassword,
];
export const DISABLED_FOR_REDIRECT_PATHS = [Subpaths.Login];
